/*
 * @Author: wyx
 * @Date: 2018-10-31 18:26:09
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2019-03-07 17:20:29
 * 地图主题配色
 *
 * featureType - 地图要素类型:
 *   - water: 水系（河流、湖泊等）
 *   - highway: 高速公路
 *   - arterial: 主干道
 *   - local: 本地道路/次要道路
 *   - land: 陆地背景
 *   - railway: 铁路
 *   - subway: 地铁
 *   - building: 建筑物
 *   - green: 绿地（公园、绿化带等）
 *   - boundary: 行政区划边界
 *   - manmade: 人造建筑
 *   - poi: 兴趣点（Point of Interest）
 *   - districtlabel: 行政区标注
 *   - all: 所有要素
 *
 * elementType - 要素的组成部分:
 *   - all: 全部
 *   - geometry: 几何形状
 *   - geometry.fill: 填充部分
 *   - geometry.stroke: 边框线条
 *   - labels: 标注（文字+图标）
 *   - labels.text: 标注文字
 *   - labels.text.fill: 标注文字填充色
 *   - labels.text.stroke: 标注文字描边
 *   - labels.icon: 标注图标
 *
 * stylers - 样式设置:
 *   - color: 颜色值（十六进制）
 *   - visibility: 可见性（on/off）
 *   - strokeWeight: 边框粗细
 */

// =================================================================================
// MapDarkCRPC - 深色主题配置 (CRPC风格)
// 主题色: 蓝色系 (#387fcc, #3880cc)
// 背景色: 深蓝灰色 (#061e34)
// 适用场景: 暗色科技风格地图展示
// =================================================================================
const MapDarkCRPC = [
  {
    featureType: "background",  // 背景
    elementType: "geometry",
    stylers: {
      visibility: "on",  // 显示背景
    },
  },
  {
    featureType: "land",
    elementType: "geometry",
    stylers: {
      color: "#061e34ff",
      visibility: "on",
    },
  },
  {
    featureType: "building",
    elementType: "geometry.fill",
    stylers: {
      color: "#001225ff",
      visibility: "on",
    },
  },
  {
    featureType: "building",
    elementType: "geometry.stroke",
    stylers: {
      color: "#00000cff",
      visibility: "on",
    },
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1a5ca4ff",
      visibility: "on",
    },
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: {
      color: "#1b263bff",
      visibility: "on",
    },
  },
  {
    featureType: "country",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "city",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "continent",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "village",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "town",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "district",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "districtlabel",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "districtlabel",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "poilabel",
    elementType: "labels.text.fill",
    stylers: {
      color: "#1b263bff",
      visibility: "on",
    },
  },
  {
    featureType: "poilabel",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "poilabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "scenicspotslabel",
    elementType: "labels.text.fill",
    stylers: {
      color: "#1b263bff",
      visibility: "on",
    },
  },
  {
    featureType: "scenicspotslabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "transportationlabel",
    elementType: "labels.text.fill",
    stylers: {
      color: "#1b263bff",
      visibility: "on",
    },
  },
  {
    featureType: "transportationlabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "airportlabel",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "airportlabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "green",
    elementType: "geometry",
    stylers: {
      color: "#415a77ff",
      visibility: "on",
    },
  },
  {
    featureType: "district",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "city",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "country",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "continent",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "town",
    elementType: "labels",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "village",
    elementType: "labels",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "town",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "city",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "railway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "subway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "highwaysign",
    elementType: "labels",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "nationalwaysign",
    elementType: "labels",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "nationalwaysign",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "provincialwaysign",
    elementType: "labels",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "provincialwaysign",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "tertiarywaysign",
    elementType: "labels",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "tertiarywaysign",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "subwaylabel",
    elementType: "labels",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "subwaylabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      weight: 1.5,
      visibility: "on",
    },
  },
  {
    featureType: "highway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "nationalway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "provincialway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "arterial",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "tertiaryway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "fourlevelway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "local",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "scenicspotslabel",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "subway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#3880ccff",
      visibility: "on",
    },
  },
  {
    featureType: "shopping",
    elementType: "geometry",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "manmade",
    elementType: "geometry",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "manmade",
    elementType: "labels",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "highwaysign",
    elementType: "labels.icon",
    stylers: {
      visibility: "off",
    },
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#0d1c2bff",
      visibility: "on",
    },
  },
  {
    featureType: "road",
    elementType: "labels.text",
    stylers: {
      fontsize: 28,
    },
  },
  {
    featureType: "highway",
    elementType: "geometry.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "highway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1a5ca4ff",
      visibility: "on",
      weight: 1.5,
    },
  },
  {
    featureType: "highway",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "nationalway",
    elementType: "geometry.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "nationalway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1a5ca4ff",
      visibility: "on",
      weight: 1.5,
    },
  },
  {
    featureType: "nationalway",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "provincialway",
    elementType: "geometry.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "geometry.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "arterial",
    elementType: "geometry.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "tertiaryway",
    elementType: "geometry.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "fourlevelway",
    elementType: "geometry.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "local",
    elementType: "geometry.fill",
    stylers: {
      color: "#387fccff",
      visibility: "on",
    },
  },
  {
    featureType: "provincialway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1a5ca4ff",
      visibility: "on",
      weight: 1.5,
    },
  },
  {
    featureType: "cityhighway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1a5ca4ff",
      visibility: "on",
      weight: 1.5,
    },
  },
  {
    featureType: "arterial",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1a5ca4ff",
      visibility: "on",
      weight: 1.5,
    },
  },
  {
    featureType: "tertiaryway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1a5ca4ff",
      visibility: "on",
      weight: 1.5,
    },
  },
  {
    featureType: "fourlevelway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1a5ca4ff",
      visibility: "on",
      weight: 1.5,
    },
  },
  {
    featureType: "local",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1a5ca4ff",
      visibility: "on",
      weight: 1.5,
    },
  },
  {
    featureType: "nationalway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6",
    },
  },
  {
    featureType: "nationalway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7",
    },
  },
  {
    featureType: "nationalway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8",
    },
  },
  {
    featureType: "nationalway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9",
    },
  },
  {
    featureType: "nationalway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6",
    },
  },
  {
    featureType: "nationalway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7",
    },
  },
  {
    featureType: "nationalway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8",
    },
  },
  {
    featureType: "nationalway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9",
    },
  },
  {
    featureType: "nationalway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6",
    },
  },
  {
    featureType: "nationalway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7",
    },
  },
  {
    featureType: "nationalway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8",
    },
  },
  {
    featureType: "nationalway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9",
    },
  },
  {
    featureType: "provincialway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "8",
    },
  },
  {
    featureType: "provincialway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "9",
    },
  },
  {
    featureType: "provincialway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "8",
    },
  },
  {
    featureType: "provincialway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "9",
    },
  },
  {
    featureType: "provincialway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "8",
    },
  },
  {
    featureType: "provincialway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "9",
    },
  },
  {
    featureType: "cityhighway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6",
    },
  },
  {
    featureType: "cityhighway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7",
    },
  },
  {
    featureType: "cityhighway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8",
    },
  },
  {
    featureType: "cityhighway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9",
    },
  },
  {
    featureType: "arterial",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "9,9",
      level: "9",
    },
  },
  {
    featureType: "arterial",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "9,9",
      level: "9",
    },
  },
  {
    featureType: "arterial",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "9,9",
      level: "9",
    },
  },
  {
    featureType: "local",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "fourlevelway",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "tertiaryway",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "arterial",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "cityhighway",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "provincialway",
    elementType: "labels.text.fill",
    stylers: {
      color: "#0d1b2aff",
      visibility: "on",
    },
  },
  {
    featureType: "scenicspots",
    elementType: "geometry",
    stylers: {
      color: "#415a77ff",
      visibility: "on",
    },
  },
];

export default {
  // 深色主题样式
  darkstyle: MapDarkCRPC,

  // =================================================================================
  // landSystemStyle - 土地系统样式
  // 主题色: 青色(#02ccff)
  // 背景色: 深蓝黑色(#001428)
  // 适用场景: 土地管理系统页面
  // =================================================================================
  landSystemStyle: MapDarkCRPC,

  // =================================================================================
  // reportSystemStyle - 报表系统样式
  // 主题色: 蓝色(#3366cc)
  // 背景色: 深蓝色(#08214b)
  // 适用场景: 报表管理系统页面
  // 说明: 比darkstyle更亮的蓝色调,适合数据展示
  // =================================================================================
  reportSystemStyle: [
    {
      featureType: "water", // 水系
      elementType: "all",
      stylers: {
        color: "#0c173d", // 深蓝紫色水体
      },
    },
    {
      featureType: "highway", // 高速公路
      elementType: "geometry.fill", // 填充
      stylers: {
        color: "#08214b", // 中深蓝色填充
      },
    },
    {
      featureType: "highway", // 高速公路
      elementType: "geometry.stroke", // 边框
      stylers: {
        color: "#1a3d6b", // 蓝色边框(比darkstyle更亮)
        strokeWeight: 1, // 边框粗细 1px
      },
    },
    {
      featureType: "highway", // 高速公路
      elementType: "labels", // 标注
      stylers: {
        visibility: "on", // 显示标注
      },
    },
    {
      featureType: "arterial", // 主干道
      elementType: "geometry.fill", // 填充
      stylers: {
        color: "#08214b", // 中深蓝色填充
      },
    },
    {
      featureType: "arterial", // 主干道
      elementType: "geometry.stroke", // 边框
      stylers: {
        color: "#0d2d5b", // 深蓝色边框
        strokeWeight: 0.5, // 边框粗细 0.5px
      },
    },
    {
      featureType: "arterial", // 主干道
      elementType: "labels", // 标注
      stylers: {
        visibility: "on", // 显示标注
      },
    },
    {
      featureType: "local", // 本地道路
      elementType: "all",
      stylers: {
        visibility: "off", // 隐藏次要道路
      },
    },
    {
      featureType: "land", // 陆地背景
      elementType: "all",
      stylers: {
        color: "#08214b", // 中深蓝色背景(比darkstyle更亮)
      },
    },
    {
      featureType: "railway", // 铁路
      elementType: "all",
      stylers: {
        visibility: "off", // 隐藏铁路
      },
    },
    {
      featureType: "subway", // 地铁
      elementType: "all",
      stylers: {
        visibility: "off", // 隐藏地铁
      },
    },
    {
      featureType: "building", // 建筑物
      elementType: "geometry",
      stylers: {
        color: "#000033", // 深蓝紫色建筑
        visibility: "on", // 显示建筑
      },
    },
    {
      featureType: "all", // 所有要素
      elementType: "labels.text.fill", // 文字填充色
      stylers: {
        color: "#3366cc", // 蓝色文字(主题色,比青色更偏蓝)
        visibility: "on", // 显示文字
      },
    },
    {
      featureType: "all", // 所有要素
      elementType: "labels.text.stroke", // 文字描边
      stylers: {
        color: "#000000", // 黑色描边,增强可读性
      },
    },
    {
      featureType: "green", // 绿地
      elementType: "geometry",
      stylers: {
        color: "#060d32", // 深蓝紫色(统一配色,不使用绿色)
      },
    },
    {
      featureType: "boundary", // 行政区划边界
      elementType: "geometry",
      stylers: {
        color: "#3366cc", // 蓝色边界
        visibility: "on", // 显示边界
      },
    },
    {
      featureType: "boundary", // 行政区划边界
      elementType: "geometry.fill", // 填充
      stylers: {
        visibility: "off", // 不填充,只显示边框线
      },
    },
    {
      featureType: "boundary", // 行政区划边界
      elementType: "geometry.stroke", // 边框
      stylers: {
        color: "#3366cc", // 蓝色边框
        strokeWeight: 2, // 边框粗细 2px(突出显示边界)
        visibility: "on", // 显示边框
      },
    },
    {
      featureType: "manmade", // 人造建筑
      elementType: "geometry",
      stylers: {
        color: "#000033", // 深蓝紫色
      },
    },
    {
      featureType: "poi", // 兴趣点
      elementType: "labels.text", // 标注文字
      stylers: {
        visibility: "on", // 显示POI文字
      },
    },
    {
      featureType: "poi", // 兴趣点
      elementType: "labels.icon", // 标注图标
      stylers: {
        visibility: "off", // 隐藏POI图标,保持简洁
      },
    },
    {
      featureType: "all", // 所有要素
      elementType: "labels.icon", // 所有图标
      stylers: {
        visibility: "off", // 隐藏所有图标,简洁样式
      },
    },
  ],
};
